/* eslint-disable radix */
import React, { Component } from "react";
import { useNavigate, useLocation } from 'react-router-dom'
import PageTitle from "../../Theme/PageTitle/index.js";
import DashboardLayout from "../../Theme/DashboardLayout/index.js";
import { Button, Modal, Table } from "antd";
import { StrokeIcon } from "../../Theme/Icon/index.js";
import Spinner from '../../Theme/Spinner/index.js';
import Widget from "../../Theme/Widget/index.js";
import AuthLogic from '../../../AuthLogic/index.js';
import { bindActionCreators } from "redux";
import * as detailedScheduleActions from '../../../redux/actions/detailedScheduleActions.js';
import * as resourceActions from '../../../redux/actions/resourceActions.js';
import * as tourActions from '../../../redux/actions/tourActions.js';
import * as mealActions from '../../../redux/actions/mealActions.js';
import * as dayTypeActions from '../../../redux/actions/dayTypeActions.js';
import * as assignmentActions from '../../../redux/actions/assignmentActions.js';
import * as WrappedDetailedScheduleEditCommentForm from './DetailedScheduleEditCommentForm.js';
import * as WrappedDetailedScheduleEditTimeForm from './DetailedScheduleEditTimeForm.js';
import DetailedScheduleTable from './DetailedScheduleTable.js';
import SelectResourceButton from '../../SelectResource/SelectResourceButton.js';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Toast } from '../../Notification/index.js';
import CRUD from '../LiveScheduleUpdate/utils/CRUD/index.js';
import dayjs from 'dayjs'
import {Divider} from 'antd';

const noComment = '_.:@NOcOMmENt@:._';

class DetailedScheduleView extends Component {
  constructor(props) {
    
    super(props);
    this.state = {
      detailedStartDate: '', // Temporary Start Date will hook up to the values selected from modal
      detailedEndDate: '',
      findResourceModal: false,
      areSearchFieldsValid: true,
      backRedirect: '',
      findResourceFields: {
        name: '',
        sso: '',
        withDisabled: false
      },
      resource: '',
      resources: '',
      resourceTable: {
        columns: [
          {
            title: 'Resource name',
            dataIndex: 'name',
            render: text => <a>{text}</a>
          },
          {
            title: 'Cost Center Name',
            dataIndex: 'dName',
            render: text => <a>{text}</a>
          },
        ],
        data: ''
      },
      loaded: false,
      openEditModal: false,
      editValue: '',
      disableButton: false
    };
  }

  componentDidMount = async () => {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.updateResource();
    this.customBrowserBackNavigation();
  }

  customBrowserBackNavigation = () => {
    // event handler for browser back button
    // Note: only works when AppRouter component wraps Switch w/ HashRouter
    window.onpopstate = () => {
      const { pathname } = this.props.navigate.location;
      if (pathname === '/detailed-schedule-view') {
        this.setState({
          backRedirect: '/schedules'
        });
      }
    }
  }

  readyApiCall = async () => {
    const userId = this.props.user.login.id;
    const resourceId = this.state.resource.id || this.props.user.login.resourceId;

    if (this.props.location.state) {
      const { detailedStartDate, detailedEndDate } = this.props.location.state;
      await this.props.actions.updateDetailedScheduleParameters({ detailedStartDate, detailedEndDate });
      this.getDataFromApi(detailedStartDate, detailedEndDate, resourceId, userId);

    } else {
      let params = _.cloneDeep(this.props.detailedScheduleParameters);

      const { detailedStartDate, detailedEndDate } = params;
      this.getDataFromApi(detailedStartDate, detailedEndDate, resourceId, userId);
    }
  }

  getDataFromApi = async (detailedStartDate, detailedEndDate, resourceId, userId) => {
    await this.props.actions.fetchDetailedSchedules(detailedStartDate, detailedEndDate, resourceId, userId)
      .catch(error => {
        console.log(error);
        alert("Your STORM Resource account is not set up correctly; please contact the STORM Team.");
      });

    this.setState({
      detailedSchedule: await this.props.detailedSchedule,
      loaded: true
    }, () => {
      this.setState({
        detailedStartDate, // TODO: format to be more UI friendly
        detailedEndDate
      });
    });
  }

  resize = () => {
    if (window.innerWidth >= 600) {
      this.setState({
        widescreen: true
      });
    } else {
      this.setState({
        widescreen: false
      });
    }
  }

  updateResource = async () => {
    this.setState({
      resource: this.props.selectedResource,
      loaded: false
    }, async () => {
      console.log(`resourceName: ${this.state.resource.name}, resourceId: ${this.state.resource.id}`);
      this.readyApiCall();
    });
  }

  generateResourceTable = () => {
    const data = [];
    const { resources } = this.state;
    const resourceTable = this.state.resourceTable;
    for (let resource of resources) {
      const row = {
        key: resource.rowId,
        id: resource.id,
        name: resource.name,
        dName: resource.dName
      };
      data.push(row);
    }
    resourceTable.data = data;
    this.setState({
      resourceTable
    });
  }

  refreshPage = () => {
    window.location.reload();
  }

  openEditModal = (value, label, title, id, offset) => {
    let tourTimes;
    let tour = {};
    switch (label) {
      case 'tourTimes':
        for (let schedule of this.props.detailedSchedule.detailedSchedules) {
          if (schedule.tourId && schedule.tourId === id) {
            tour = { ...schedule } // added
            tourTimes = {
              startTime: dayjs.unix(schedule.timeStart).add(offset, 'minute'),
              endTime: dayjs.unix(schedule.timeEnd).add(offset, 'minute'),
              offset
            }
            break;
          }
        }
        break;
      case 'mealTimes': // Can be updated to find assignment as well
        for (let schedule of this.props.detailedSchedule.detailedSchedules) {
          if (schedule.tourId && schedule.tourId === id) {
            tourTimes = {
              startTime: dayjs.unix(schedule.timeStart).add(offset, 'minute'),
              endTime: dayjs.unix(schedule.timeEnd).add(offset, 'minute')
            }
            break;
          }
        }
        break;
      case 'assignTimes': // Can be updated to find assignment as well
        for (let schedule of this.props.detailedSchedule.detailedSchedules) {
          if (schedule.tourId && schedule.tourId === id.tourId) {
            tourTimes = {
              startTime: dayjs.unix(schedule.timeStart).add(offset, 'minute'),
              endTime: dayjs.unix(schedule.timeEnd).add(offset, 'minute'), 
              isApproved: schedule.approved =='1' ? true: false
            }
            break;
          }
        }
        break;
      default:
        break;
    }

    this.setState({
      openEditModal: true,
      editValue: value,
      modalLabel: label,
      modalTitle: title,
      editId: id,
      offset,
      tourTimes,
      tour
    });
  }

  handleEditCancel = () => {
    this.setState({ openEditModal: false });
  }

  handleEditSubmit = async (value, label) => {
    this.setState({ disableButton: true });
    let resourceId = this.state.resource.id || this.props.user.login.resourceId;
    let personnelData = await this.getResourceDetails(resourceId);
    let clonedDetailedSchedule;
    for (let detailedSchedule of this.state.detailedSchedule.detailedSchedules) {
      if (detailedSchedule.tourId === this.state.editId || detailedSchedule.rdtId === this.state.editId || detailedSchedule.tourId === this.state.editId.tourId) {
        clonedDetailedSchedule = _.cloneDeep(detailedSchedule);
        clonedDetailedSchedule.resourceId = this.state.resource.id;
        let timeStart = value.timeStart ? value.timeStart
          : dayjs.unix(clonedDetailedSchedule.timeStart).add(this.state.offset, 'minute');
        let timeEnd = value.timeEnd ? value.timeEnd
          : dayjs.unix(clonedDetailedSchedule.timeEnd).add(this.state.offset, 'minute');
        if (label === "myTourComment" || label === "tourTimes" || value.changeTour) {
          try {
            if (value.changeTour == true) {
              if (timeStart > this.state.tourTimes.startTime) timeStart = this.state.tourTimes.startTime
              if (timeEnd < this.state.tourTimes.endTime) timeEnd = this.state.tourTimes.endTime
            }
            let startDate = dayjs.unix(clonedDetailedSchedule.timeStart)
              .add(this.state.offset, 'minute').format('M/D/YYYY');
            await this.props.actions.fetchTour({ resourceId, startDate })
              .catch(error => {
                this.setState({ disableButton: false });
                throw new Error(error)
            });
            let tourValue = await this.props.tour;
            let parameters = {
              tourId: value.changeTour == true ? this.state.editId.tourId : this.state.editId,
              resourceId,
              dateTimeStartActual: timeStart.format('YYYY-MM-DD HH:mm:ss'),
              dateTimeEndActual: timeEnd.format('YYYY-MM-DD HH:mm:ss'),
              unionId: tourValue.data.unionId,
              contractId: tourValue.data.contractId,
              contractRulesGroupId: tourValue.data.contractRulesGroupId,
              salaryLevelId: tourValue.data.salaryLevelId || 0,
              timeZoneId: tourValue.data.timeZoneId,
              userId: this.props.user.login.id,
              comment: label === "myTourComment" && value ? value
                : label === "myTourComment" && !value ? ' '
                : clonedDetailedSchedule.comment ? clonedDetailedSchedule.comment : null,
              comment15: tourValue.data.comment15 ? tourValue.data.comment15 : " ",
              notification: tourValue.data.notification ? tourValue.data.notification : " ",
              showBusy: tourValue.data.showBusy,
              postTK: clonedDetailedSchedule.postTK === "1" ? true : false,
              TKComment: tourValue.data.tkComment ? tourValue.data.tkComment : " ",
              baseRateId: tourValue.data.baseRateId,
              baseOverrideType: tourValue.data.baseOverrideType,
              baseOverride: tourValue.data.baseOverride,
              jobSalaryId: tourValue.data.jobSalaryId,
              approverComment: tourValue.data.approverComment || " ",
              iPAddress: tourValue.data.iPAddress,
              reconciled: tourValue.data.reconciled,
              costCenterId: tourValue.data.costCenterId,
              doLog: tourValue.data.doLog,
              contractUpdateInfo: tourValue.data.contractUpdateInfo,
              wBSId: tourValue.data.wBSId,
              hyphenateAgreementId: tourValue.data.hyphenateAgreementId,
              jobSalaryUpgradeId: tourValue.data.jobSalaryUpgradeId
          }
          if(parameters.comment) {
            parameters.comment = parameters.comment.replace("”", '"').replace("“", '"').replace("’","'").replace("‘","'").replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"').replace(/[\u2013\u2014]/g, '-').replace(/[\u2026]/g, '...');
          }
            this.updateValues(
              this.props.actions.updateTour, parameters, "tour", timeStart.format('YYYY-MM-DD'));
          } catch (error) { alert(error) }
        }
        if (label === "mealTimes") {
          try {
            let mealId = clonedDetailedSchedule.meals[0].mealId;
            await this.props.actions.fetchMeal({ mealId })
              .catch(error => {
                this.setState({ disableButton: false });
                throw new Error(error)
              });
            let meal = await this.props.meal;

            this.updateValues(
              this.props.actions.editMeal,
              {
                tourId: clonedDetailedSchedule.tourId,
                mealId,
                startTime: value.timeStart.format('YYYY-MM-DD HH:mm:ss'),
                endTime: value.timeEnd.format('YYYY-MM-DD HH:mm:ss'),
                userId: this.props.user.login.id,
                jobElementId: meal.data[0].jobElementId,
                OTE: meal.data[0].OTE,
                billable: meal.data[0].billable,
                autoAdd: meal.data[0].autoAdd,
              }, "meal", value.timeStart.format('YYYY-MM-DD'));
          } catch (error) {
            alert(error)
          }
        } else if (label === "myDayComment") {
          let result;
          let date
          try {
            let resourceId = personnelData.resourceId;
            date = dayjs.unix(clonedDetailedSchedule.rdtDate)
              .add(this.state.offset, 'minute')
              .format('YYYY-MM-DD');
            await this.props.actions.fetchResourceDayTypeByDate(resourceId, date)
              .catch(error => {
                this.setState({ disableButton: false });
                throw new Error(error);
              })
            result = await this.props.resourceDayType;
          } catch (error) {
            alert(error);
            this.setState({ disableButton: false });
          }
          if (result.counter === 0) {
            alert('Unable to find Day Type in database');
            this.setState({ disableButton: false });
          } else {
            this.updateValues(
              this.props.actions.editResourceDayTypeComment,
              {
                resourceDayTypeId: result.data[0].resourceDayTypeId,
                userId: this.props.user.login.id,
                myComment: value ? value : noComment,           
              }, "resourceDayTypeComment", date);
          }
        } else if (label === 'assignTimes' || label === 'myAssignComment') { // <- James
          //fetch assignment
          await this.props.actions.fetchAssignment(this.state.editId.jobId)
            .catch(error => {
              this.setState({ disableButton: false });
              throw new Error(error);
            })

          let assignment = this.props.assignment.data.filter(assign => {
            return assign.id == this.state.editId.serviceId;
          });

          // start log
          const userId = this.props.user.login.id;
          const resourceName = this.state.resource.name || this.props.user.userDemographics.name // this.state.editId.resourceName;
          console.log('resourceName', resourceName)
          const jobId = this.state.editId.jobId;
          const day = dayjs(assignment[0].startActual).format('M/D/YYYY (ddd)');
          let logControlId;
          let logJobStart = this.props.actions.logJobStart;
          let logJobFinish = this.props.actions.logJobFinish;

          await CRUD.updateAssignment.logStart({ userId, resourceName, day, logJobStart });
          logControlId = this.props.logJobStartRecord.logControlId;

          let assignParams = {
            finalFormValidation: () => { return true },
            logControlId: 0,
            state: {},
            userId,
            updateState: (newState) => { // might just put a dummy stub here
              for (let [key, value] of Object.entries(newState)) {
                this.setState({
                  [key]: value
                });
              }
            },
            editJobElement: this.props.actions.editJobElement,
            refreshPage: this.props.actions.updatePage
          };

          assignParams.state.itemDetails = {
            jobElementId: assignment[0].id,
            jobId: assignment[0].jobId,
            tourId: assignment[0].tourId,
            resourceId,
            resourceName,
            executingBranchId: assignment[0].executingBranchId,
            serviceId: assignment[0].serviceId,
            relatedServiceId: assignment[0].relatedServiceId,
            status: assignment[0].status,
            startRequest: assignment[0].startRequest,
            endRequest: assignment[0].endRequest,
            assignmentStartTime: value.timeStart ? value.timeStart : dayjs(assignment[0].startActual).add(this.state.offset, 'minute'),
            assignmentEndTime: value.timeEnd ? value.timeEnd : dayjs(assignment[0].endActual).add(this.state.offset, 'minute'),
            timeZoneId: assignment[0].timeZoneId,
            orderingUserId: assignment[0].orderingUserId,
            updatingUserId: userId,
            descriptionComment: assignment[0].descriptionComment || " ",
            approverComment: assignment[0].approverComment || " ",
            employeeComment: label === 'myAssignComment' ? value.replace("”", '"').replace("“", '"').replace("’","'").replace("‘","'").replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"').replace(/[\u2013\u2014]/g, '-').replace(/[\u2026]/g, '...') : assignment[0].employeeComment || " ",
            schedulerComment: assignment[0].schedulerComment || " ",
            isAnUpgrade: assignment[0].isAnUpgrade,
            overTime: assignment[0].overTime,
            activityType: assignment[0].activityType,
            overTimeType: assignment[0].overTimeType || 0,
            overTimeReason: assignment[0].overTimeReason || " ",
            costObject: {
              costObjectId: assignment[0].costObjectId,
              costObjectTypeId: assignment[0].costObjectTypeId
            },
            jobSalaryUpgradeId: assignment[0].jobSalaryUpgradeId,
            hourlyActivityRateFlag: assignment[0].hourlyActivityRateFlag,
            rate: assignment[0].rate,
            nabetTracker: assignment[0].nabetTracker,
            eventNote: assignment[0].eventNote,
            skillShowId: assignment[0].skillShowId,
            skillFacilityId: assignment[0].skillFacilityId,
            chgTz: assignment[0].chgTz,
          };

          
          await CRUD.updateAssignment.updateJobElement(assignParams);
          await CRUD.updateAssignment.logFinish({ resourceName, logControlId, jobId, day, logJobFinish });

          this.updatePage(); // esto se debe enviar dentro de las variables del updateJobElement
          this.setState({ openEditModal: false });
        }
        break;
      }
    }
    this.setState({ disableButton: false });
  }

  updatePage = async () => {
    this.setState({
      loaded: false
    }, async () => {
      this.readyApiCall();
    });
  }

  updateValues = async (updateFunction, parameters, updateType, date) => {
    let propUpdateType = this.getUpdateType(updateType);
    await updateFunction(parameters)
      .then(async () => {
        let response = await propUpdateType;
        if (response.status) {
          let message = updateType === 'tour' ? "Tour was succesfully updated"
            : "Meal was succesfully updated";
          this.displayToastAndRefreshPage(message, true, date);
        }
      })
      .catch((error) => {
        let message = '';
        if (error.errors) {

          for (let e of error.errors) {
            let position = e.message.search('->');
            position > 0 ? message += e.message.substr(position + 2) : message += e.message;
            // message += e.message;
          }
          this.displayToastAndRefreshPage(message, false, date);
          // For updating dayType fields because redux behaves differently
        } else {
          message = 'Day Type was successfully updated.';
          this.displayToastAndRefreshPage(message, true, date);
        }
      });
  }

  getResourceDetails = async (resourceId) => {
    await this.props.actions.fetchResourcePersonnelData(resourceId).catch(error => {
      alert("Loading resourcePersonnelData failed\n" + JSON.stringify(error));
    });
    return this.props.resourcePersonnelData.data[0];
  }

  displayToastAndRefreshPage = (message, type, date) => {
    let notification = {
      type: type ? 'success' : 'error',
      message: message,
      description: `For ${this.state.resource.name || this.props.user.userDemographics.name} on ${date}`
    };
    this.updatePage();
    this.setState({ openEditModal: false });
    Toast(notification);
  }

  getUpdateType = (updateType) => {
    switch (updateType) {
      case 'meal':
        return this.props.meal;
      case 'resourceDayType':
        return this.props.resourceDayType;
      case 'assignment':
        return this.props.assignment;
      default:
        return this.props.tour;
    }
  }

  render() {

    const resourcesId = { 'resourceId': this.state.resource.id || "", 'userResourceId': this.props.user.login.resourceId }

    if (this.state.backRedirect && !this.props.hamburgerMenu) {
      window.history.pushState(null, null, '#/schedules');
      this.props.navigate(this.state.backRedirect);
    }
    if (this.state.loaded) {
      return (
        <DashboardLayout>
          <PageTitle title={'Details for Tours/Assignments/Day Types'} subTitle={this.state.resource.name || this.props.user.userDemographics.name} />
          <DetailedScheduleTable
            resourceName={this.state.resource.name || this.props.user.userDemographics.name}
            openModal={this.openEditModal}
            resourcesId={resourcesId}
          />
          {
            this.state.openEditModal ?
              <Modal
                zIndex={2000}
                title={this.state.modalTitle}
                open={this.state.openEditModal}
                onCancel={this.handleEditCancel}
                footer={null}
              >
                <Divider />
                {
                  this.state.modalLabel.includes("Times") ?
                    <WrappedDetailedScheduleEditTimeForm.default
                      editValue={this.state.editValue}
                      labelValue={this.state.modalLabel}
                      handleComponentEditSubmit={this.handleEditSubmit}
                      handleEditCancel={this.handleEditCancel}
                      buttonDisable={this.state.disableButton}
                      tourTimes={this.state.tourTimes}
                      tour={this.state.tour}
                    />
                    : <WrappedDetailedScheduleEditCommentForm.default
                      editValue={this.state.editValue}
                      labelValue={this.state.modalLabel}
                      handleEditCancel={this.handleEditCancel}
                      handleComponentEditSubmit={this.handleEditSubmit}
                      buttonDisable={this.state.disableButton}
                    />
                }
                
              </Modal> : null
          }

          {(AuthLogic.changeAssignmentsResource(this.props.user) || AuthLogic.changeAbsencesResource(this.props.user)) &&
            (
              (<SelectResourceButton updatePageCallback={this.updateResource} />)
            )
          }
        </DashboardLayout>
      )
    } else return <Spinner />
  }
}

DetailedScheduleView.propTypes = {
  actions: PropTypes.object.isRequired,
  detailedSchedule: PropTypes.object.isRequired,
  hamburgerMenu: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    user: state.user,
    resources: state.resources,
    detailedSchedule: state.detailedSchedules,
    selectedResource: state.selectedResource,
    hamburgerMenu: state.navigation.hamburgerMenu,
    tourComment: state.tourComment,
    meal: state.meal,
    tour: state.tour,
    resourcePersonnelData: state.resourcePersonnelData,
    resourceDayType: state.resourceDayType,
    assignment: state.jobElements,
    logJobStartRecord: state.logJobStartRecord,
    detailedScheduleParameters: state.detailedScheduleParameters
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchDetailedSchedules: bindActionCreators(
        detailedScheduleActions.fetchDetailedSchedules,
        dispatch
      ),
      updateDetailedScheduleParameters: bindActionCreators(
        detailedScheduleActions.updateDetailedScheduleParameters,
        dispatch
      ),
      fetchFindResource: bindActionCreators(
        resourceActions.fetchFindResource,
        dispatch
      ),
      updateSelectedResource: bindActionCreators(
        resourceActions.updateSelectedResource,
        dispatch
      ),
      updateTour: bindActionCreators(
        tourActions.editTour,
        dispatch
      ),
      fetchResourcePersonnelData: bindActionCreators(
        resourceActions.fetchResourcePersonnelData,
        dispatch
      ),
      fetchResourceDayTypeByDate: bindActionCreators(
        dayTypeActions.fetchResourceDayTypeByDate,
        dispatch
      ),
      editResourceDayType: bindActionCreators(
        dayTypeActions.editResourceDayType,
        dispatch
      ),
      editResourceDayTypeComment: bindActionCreators(
        dayTypeActions.editResourceDayTypeComment,
        dispatch
      ),
      editMeal: bindActionCreators(
        mealActions.editMeal,
        dispatch
      ),
      fetchTour: bindActionCreators(
        tourActions.fetchTour,
        dispatch
      ),
      fetchMeal: bindActionCreators(
        mealActions.fetchMeal,
        dispatch
      ),
      fetchAssignment: bindActionCreators(
        assignmentActions.fetchJobElements,
        dispatch
      ),
      editJobElement: bindActionCreators(
        assignmentActions.editJobElement,
        dispatch
      ),
      logJobStart: bindActionCreators(
        assignmentActions.logJobStart,
        dispatch
      ),
      logJobFinish: bindActionCreators(
        assignmentActions.logJobFinish,
        dispatch
      ),
    }
  };
}

export const withRouter = (Component) => {
	const Wrapper = (props) => {
		const navigate = useNavigate();
    const location = useLocation();
		return <Component navigate={navigate} {...props} location={location} />;
	};
	return Wrapper;
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(DetailedScheduleView));